import React from "react";
import Contact from "../components/Contact";
import { Layout } from "../components/Layout";

const ContactPage = () => {
  return (
    <Layout>
      <Contact />
    </Layout>
  );
};

export default ContactPage;
